//this effect is used to load the filter profiles for the current user when cso is set|changed

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { LogService } from "@services/log.service";
import { Injectable } from "@angular/core";
import { FilterProfileService } from "@services/filter-profile.service";
import { catchError, exhaustMap, map, of } from "rxjs";
import * as UserProfileActions from '../actions/user-profile.actions';
import * as FilterActions from '../actions/filter.action';
import { IFilterProfile } from "@interfaces/tankProfile";

@Injectable()
export class UserInformationEffect {
  constructor(private actions$: Actions,
    private filterProfileService: FilterProfileService,
    private logger: LogService,) {
  };

  // Put the user into the store as soon as we have it. Everything that keys off the CSO id -
  // the tank grid datasource above all - is gated on this action, so it must not wait on any
  // unrelated fetch.
  setUserInfo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserProfileActions.GET_USER_INFO),
      map((action) => new UserProfileActions.SetUserInfo(
        (action as UserProfileActions.GetUserInfo).userInformation
      ))
    );
  });

  // Filter profiles only feed the header dropdown, so they load alongside the user rather than
  // in front of them.
  loadFilterProfiles$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserProfileActions.GET_USER_INFO),
      exhaustMap((action) => {
        const userInfo = (action as UserProfileActions.GetUserInfo).userInformation;
        return this.filterProfileService
          .getFilterProfiles(userInfo.lastSelectedOrganizationId)
          .pipe(
            catchError((error) => {
              this.logger.debug('Failed to load filter profiles', error?.message);
              return of([] as IFilterProfile[]);
            })
          );
      }),
      map((filterProfiles: IFilterProfile[]) => new FilterActions.SetFilterProfiles(filterProfiles))
    );
  });

}
